module.exports = __webpack_public_path__ + "public/img/Mengelola Gaji Karyawan Dengan Microsoft Excel.893c6deb.png";